export enum NetworkQuality {
  Good = "Good",
  Medium = "Medium",
  Bad = "Bad",
}

export enum NetworkConditionStatus {
  PACKET_LOSS = "packet_loss",
  LATENCY_VARIATION = "latency_variation",
  HIGH_LATENCY = "high_latency",
  // Tracked for analytics only; has no toast message (see getNetworkConditionMessage).
  BANDWIDTH = "bandwidth",
}
